import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] React crash:', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    const stack = (this.state.error && this.state.error.stack) || String(this.state.error);
    const componentStack = (this.state.info && this.state.info.componentStack) || '';

    return (
      <div style={{
        fontFamily: 'system-ui, sans-serif',
        padding: '2rem',
        maxWidth: '900px',
        margin: '0 auto',
        color: '#1a1a1a',
      }}>
        <div style={{ background: '#fee2e2', border: '2px solid #ef4444', borderRadius: '12px', padding: '1.5rem', marginBottom: '1rem' }}>
          <h1 style={{ color: '#b91c1c', fontSize: '22px', marginBottom: '0.5rem' }}>⚠️ L'application a planté</h1>
          <p style={{ color: '#7f1d1d', fontSize: '14px', marginBottom: '0' }}>
            Copie le message ci-dessous et envoie-le pour qu'on puisse corriger rapidement.
          </p>
        </div>

        <div style={{ background: '#0a1929', color: '#e5e7eb', padding: '1.2rem', borderRadius: '10px', fontFamily: 'monospace', fontSize: '12px', overflow: 'auto', marginBottom: '1rem' }}>
          <div style={{ color: '#fca5a5', fontWeight: 'bold', marginBottom: '8px' }}>ERREUR :</div>
          <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{stack}</pre>
          {componentStack && (
            <>
              <div style={{ color: '#fca5a5', fontWeight: 'bold', margin: '12px 0 8px' }}>COMPOSANT :</div>
              <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>{componentStack}</pre>
            </>
          )}
        </div>

        <button onClick={() => window.location.reload()} style={{
          padding: '10px 20px', background: '#0A1929', color: 'white',
          border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', marginRight: '8px',
        }}>🔄 Recharger</button>
        <a href="/test.html" style={{
          padding: '10px 20px', background: '#A87A1C', color: 'white',
          borderRadius: '8px', fontSize: '14px', fontWeight: '600', textDecoration: 'none', display: 'inline-block',
        }}>Tester /test.html</a>
      </div>
    );
  }
}
